import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { systemMessagesApi } from "../api/systemMessages";
import type { SystemMessageFormData } from "../types";

export const KEYS = {
  all: ["system-messages"] as const,
  list: ["system-messages", "list"] as const,
  options: ["system-messages", "recipient-options"] as const,
  receipts: (id: string) => ["system-messages", "receipts", id] as const,
  pending: ["system-messages", "pending"] as const,
};

/** Wiadomości wysłane przez zalogowanego (CEO / dev widzi wszystkie). */
export function useSentSystemMessages(enabled: boolean) {
  return useQuery({
    queryKey: KEYS.list,
    queryFn: systemMessagesApi.list,
    enabled,
  });
}

/** Pracownicy do wyboru — pobierani dopiero po otwarciu okna wysyłki. */
export function useRecipientOptions(enabled: boolean) {
  return useQuery({
    queryKey: KEYS.options,
    queryFn: systemMessagesApi.recipientOptions,
    enabled,
  });
}

/** Kto potwierdził, a kto jeszcze nie — rozwijane pod wiadomością. */
export function useSystemMessageReceipts(id: string, enabled: boolean) {
  return useQuery({
    queryKey: KEYS.receipts(id),
    queryFn: () => systemMessagesApi.receipts(id),
    enabled,
  });
}

export function useSendSystemMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: SystemMessageFormData) => systemMessagesApi.send(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });
}
